"use client";

import { useEffect, useState } from "react";
import { getWorldCupHeroCountdownDays } from "@/lib/world-cup-constants";

export function WorldCupHeroCountdownValue({ initialDays }: { initialDays: number }) {
  const [days, setDays] = useState(initialDays);

  useEffect(() => {
    function updateDays() {
      setDays(getWorldCupHeroCountdownDays());
    }

    updateDays();
    const id = window.setInterval(updateDays, 60_000);
    return () => window.clearInterval(id);
  }, []);

  return <>{days}</>;
}
